import type { SessionLifecycleLoadResult } from '@core/entities/SessionLifecycle';
import type { SessionLifecycleGateway } from '@core/ports/SessionLifecycleGateway';

export class GetSessionLifecycleUseCase {
  public constructor(private readonly sessionLifecycleGateway: SessionLifecycleGateway) {}

  public async execute(): Promise<SessionLifecycleLoadResult> {
    return this.sessionLifecycleGateway.getStatus();
  }
}